var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 20,
    viewBox: "0 0 73 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.6472 8.61311V19.6877H7.85075V4.38516H0V1.21826H4.24966C8.33379 1.21826 11.6445 4.52898 11.6445 8.61311H11.6472Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.4766 5.49805H23.1889V19.6853H19.4766V5.49805Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M24.418 5.49805H35.4383V8.38271H24.418V5.49805ZM28.0706 5.49805H31.783V19.688H28.0706V5.49805Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M53.7807 5.49805V10.3122C52.546 11.4139 51.3167 12.4696 50.0684 13.3271V5.49805H53.7807Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M59.394 11.9458V19.6853H55.6816V14.9824C57.356 13.4682 59.3316 11.9892 59.394 11.9458Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M47.9555 16.3501C47.8198 16.4288 47.676 16.5048 47.5268 16.5753C46.7479 16.9335 45.8334 17.1262 44.7832 17.1452C45.8741 17.1154 46.927 16.825 47.9555 16.3528V16.3501Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M72.0975 11.0068V19.6852H68.3852V11.6635C68.3852 10.464 68.0948 9.58479 67.5141 9.02305C66.9361 8.46132 65.989 8.18181 64.6756 8.18181C64.6159 8.18181 64.5507 8.18181 64.491 8.18181C63.818 8.19809 63.1912 8.30664 62.6104 8.50202C62.6104 8.50202 62.6095 8.50202 62.6077 8.50202C61.5141 8.83581 60.4476 9.4084 59.3974 10.1302C59.3268 10.1791 57.3214 11.6879 55.6851 13.1669C55.0528 13.7395 54.4178 14.3229 53.78 14.8982C52.5833 15.9783 51.3757 17.0176 50.1382 17.8752C48.3201 19.1343 46.434 19.9973 44.4178 19.9973C44.2576 19.9973 44.1057 19.9918 43.9591 19.9837C43.7828 19.9918 43.6009 19.9973 43.4164 19.9973C42.008 19.9973 40.7271 19.6879 39.5792 19.0692C38.4259 18.4505 37.5141 17.5848 36.8384 16.4722C36.1627 15.3596 35.8262 14.0678 35.8262 12.6024C35.8262 11.137 36.1681 9.79646 36.852 8.68927C37.5358 7.5875 38.4666 6.72726 39.6362 6.10854C40.8031 5.4871 42.1355 5.18045 43.6172 5.18045C45.2536 5.18045 46.5724 5.51152 47.5711 6.16824C47.8804 6.37176 48.1654 6.597 48.4232 6.84666V9.11261C48.1518 8.91451 47.8479 8.74083 47.5141 8.59429C46.7027 8.24151 45.7393 8.06783 44.6159 8.06783C43.0392 8.06783 41.8099 8.48031 40.9361 9.30799C40.0596 10.1357 39.6226 11.2347 39.6226 12.6024C39.6226 13.5142 39.8316 14.3121 40.2495 14.9878C40.6674 15.6608 41.2536 16.1899 42.0026 16.5726C42.7543 16.9498 43.6254 17.1425 44.6131 17.1425C44.6701 17.1425 44.7271 17.1425 44.7841 17.1425C45.8343 17.1235 46.7488 16.9335 47.5277 16.5726C47.6769 16.502 47.8207 16.426 47.9564 16.3473C47.9591 16.3446 47.9646 16.3419 47.9673 16.3392C48.6674 16.0163 49.3594 15.6065 50.0433 15.1343C50.0514 15.1316 50.0568 15.1262 50.0677 15.118C51.316 14.2605 52.5453 13.2049 53.78 12.1031C54.4123 11.5387 55.0473 10.9634 55.6851 10.3989C56.8954 9.32427 58.1247 8.28764 59.3974 7.42197C61.3458 6.09768 63.3947 5.18316 65.6335 5.18316C65.7502 5.18045 65.8696 5.17773 65.989 5.17773C66.8655 5.17773 67.6742 5.29171 68.415 5.51966C69.1586 5.74761 69.8045 6.09768 70.3553 6.57529C70.9089 7.0529 71.335 7.65806 71.6389 8.38805C71.9429 9.12075 72.0975 9.99185 72.0975 10.9986V11.0068Z",
    fill: "#D0F500"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    opacity: 0.57,
    d: "M64.4919 8.18457C63.8542 8.20357 63.2273 8.31483 62.6113 8.50479C63.1948 8.3094 63.8189 8.20085 64.4919 8.18457Z",
    fill: "#FF0000"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M21.3752 4.14111C22.5188 4.14111 23.4458 3.21409 23.4458 2.07056C23.4458 0.92702 22.5188 0 21.3752 0C20.2317 0 19.3047 0.92702 19.3047 2.07056C19.3047 3.21409 20.2317 4.14111 21.3752 4.14111Z",
    fill: "#D0F500"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M17.8039 1.21826H11.6465V4.38515H17.8039V1.21826Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M28.0703 1.61719V5.49779H31.7827C31.7827 5.49779 31.7827 5.26983 31.7827 1.61719H28.0703Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.34a80a5e05ad40a7317679c54dd29e82.svg";
export { ForwardRef as ReactComponent };